// src/pages/FirmaYonetimi.js

import React, { useState, useEffect } from "react";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { getAuth } from "firebase/auth";
import ilIlceData from "../data/iller-ilceler.json";

const FirmaYonetimi = () => {
  const [firmalar, setFirmalar] = useState([]);
  const [filtre, setFiltre] = useState("");
  const [il, setIl] = useState("");
  const [ilceler, setIlceler] = useState([]);
  const [aktifSayfa, setAktifSayfa] = useState(1);
  const [yeniFirma, setYeniFirma] = useState({
    firmaAdi: "",
    kdvOrani: "",
    vergiNo: "",
    vergiDairesi: "",
    yetkili: "",
    telefon: "",
    adres: "",
    aciklama: "",
    active: true,
    il: "",
    ilce: "",
  });
  const [duzenlenenId, setDuzenlenenId] = useState(null);

  useEffect(() => {
    const fetchFirmalar = async () => {
      const snap = await getDocs(collection(db, "firms"));
      const list = snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setFirmalar(list.sort((a, b) => a.firmaAdi.localeCompare(b.firmaAdi, "tr")));
    };
    fetchFirmalar();
  }, []);

  useEffect(() => {
    const selectedIl = ilIlceData.find((i) => i.il.toLowerCase() === il.toLowerCase());
    setIlceler(selectedIl ? selectedIl.ilceler.sort((a, b) => a.localeCompare(b, 'tr')) : []);
  }, [il]);

  const sayfaBasinaFirma = 10;
  const filtreliFirmalar = firmalar.filter((f) =>
    f.firmaAdi?.toLowerCase().includes(filtre.toLowerCase())
  );
  const toplamSayfa = Math.ceil(filtreliFirmalar.length / sayfaBasinaFirma);
  const gosterilecekFirmalar = filtreliFirmalar.slice(
    (aktifSayfa - 1) * sayfaBasinaFirma,
    aktifSayfa * sayfaBasinaFirma
  );

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    if (name === "vergiNo" && value !== "" && !/^\d{0,11}$/.test(value)) return;
    if (name === "kdvOrani" && value !== "" && (!/^\d{0,2}$/.test(value) || value < 1 || value > 100)) return;
    if (name === "telefon" && !/^\d{0,15}$/.test(value)) return;

    setYeniFirma((prev) => ({ ...prev, [name]: val }));
    if (name === "il") setIl(value);
  };

  const firmaKaydet = async () => {
    const user = getAuth().currentUser;
    if (!user) return alert("Giriş yapmadan işlem yapılamaz!");

    if (!yeniFirma.firmaAdi || !/^\d{10,11}$/.test(yeniFirma.vergiNo)) {
      alert("Firma Adı zorunludur ve Vergi No yalnızca 10 veya 11 haneli sayı olmalıdır.");
      return;
    }

    if (!duzenlenenId) {
      const q = query(collection(db, "firms"), where("vergiNo", "==", yeniFirma.vergiNo));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        alert("Bu vergi numarasıyla kayıtlı başka bir firma mevcut.");
        return;
      }
      await addDoc(collection(db, "firms"), {
        ...yeniFirma,
        createdAt: new Date(),
        createdBy: user.email,
      });
    } else {
      await updateDoc(doc(db, "firms", duzenlenenId), {
        ...yeniFirma,
        updatedAt: new Date(),
        updatedBy: user.email,
      });
      setDuzenlenenId(null);
    }

    alert("Firma başarıyla kaydedildi.");
    setYeniFirma({
      firmaAdi: "",
      kdvOrani: "",
      vergiNo: "",
      vergiDairesi: "",
      yetkili: "",
      telefon: "",
      adres: "",
      aciklama: "",
      active: true,
      il: "",
      ilce: "",
    });
  };

  const handleFirmaSec = (f) => {
    setYeniFirma({ ...f });
    setIl(f.il);
    setDuzenlenenId(f.id);
  };

  return (
    <div className="firma-yonetimi" style={{ maxWidth: 1200, margin: "auto", padding: 20 }}>
      <style>{`
        table {
          border-collapse: collapse;
          width: 100%;
        }
        th, td {
          border: 1px solid #ccc;
          padding: 6px 8px;
          text-align: left;
        }
        thead {
          background-color: #f3f4f6;
        }
        tbody tr:nth-child(even) {
          background-color: #f9fafb;
        }
        tbody tr:hover {
          background-color: #e0f2fe;
          cursor: pointer;
        }
      `}</style>

      <h2 style={{ fontSize: "20px", fontWeight: "bold", marginBottom: 16 }}>Firma Yönetimi</h2>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 20 }}>
        <input name="firmaAdi" value={yeniFirma.firmaAdi} onChange={handleInput} placeholder="Firma Adı" />
        <input name="kdvOrani" value={yeniFirma.kdvOrani} onChange={handleInput} placeholder="KDV Oranı (1-100)" />
        <input name="vergiNo" value={yeniFirma.vergiNo} onChange={handleInput} placeholder="Vergi No (10-11 hane)" />
        <input name="vergiDairesi" value={yeniFirma.vergiDairesi} onChange={handleInput} placeholder="Vergi Dairesi" />
        <input name="yetkili" value={yeniFirma.yetkili} onChange={handleInput} placeholder="Yetkili Adı" />
        <input name="telefon" value={yeniFirma.telefon} onChange={handleInput} placeholder="Telefon" />
        <select name="il" value={yeniFirma.il} onChange={handleInput}>
          <option value="">İl Seçin</option>
          {ilIlceData.map((i) => (
            <option key={i.il} value={i.il}>{i.il}</option>
          ))}
        </select>
        <select name="ilce" value={yeniFirma.ilce} onChange={handleInput}>
          <option value="">İlçe Seçin</option>
          {ilceler.map((ilce) => (
            <option key={ilce} value={ilce}>{ilce}</option>
          ))}
        </select>
        <input name="adres" value={yeniFirma.adres} onChange={handleInput} placeholder="Adres" style={{ gridColumn: "span 2" }} />
        <input name="aciklama" value={yeniFirma.aciklama} onChange={handleInput} placeholder="Açıklama" style={{ gridColumn: "span 2" }} />
        <label style={{ gridColumn: "span 2" }}>
          <input type="checkbox" name="active" checked={yeniFirma.active} onChange={handleInput} /> Aktif
        </label>
      </div>

      <button onClick={firmaKaydet} style={{ backgroundColor: "#16a34a", color: "white", padding: "6px 14px", borderRadius: 4, border: "none", cursor: "pointer", marginBottom: 20 }}>
        {duzenlenenId ? "Güncelle" : "Kaydet"}
      </button>

      <div style={{ marginBottom: 10 }}>
        <input
          type="text"
          placeholder="Firma Adı içinde ara..."
          value={filtre}
          onChange={(e) => setFiltre(e.target.value)}
          style={{ padding: 6, width: 250 }}
        />
      </div>

      <div style={{ overflowX: "auto" }}>
        <table>
          <thead>
            <tr>
              <th>Firma</th>
              <th>Vergi No</th>
              <th>KDV</th>
              <th>Yetkili</th>
              <th>Telefon</th>
              <th>İl</th>
              <th>İlçe</th>
              <th>Aktif</th>
            </tr>
          </thead>
          <tbody>
            {gosterilecekFirmalar.map((f) => (
              <tr key={f.id} onClick={() => handleFirmaSec(f)}>
                <td>{f.firmaAdi}</td>
                <td>{f.vergiNo}</td>
                <td>%{f.kdvOrani}</td>
                <td>{f.yetkili}</td>
                <td>{f.telefon}</td>
                <td>{f.il}</td>
                <td>{f.ilce}</td>
                <td style={{ textAlign: "center" }}>{f.active ? "✔️" : "❌"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: "center", marginTop: 20 }}>
        {Array.from({ length: toplamSayfa }, (_, i) => i + 1).map((s) => (
          <button
            key={s}
            onClick={() => setAktifSayfa(s)}
            style={{
              margin: 3,
              padding: "5px 10px",
              backgroundColor: aktifSayfa === s ? "#3b82f6" : "white",
              color: aktifSayfa === s ? "white" : "black",
              border: "1px solid #ccc",
              borderRadius: 4,
              cursor: "pointer"
            }}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FirmaYonetimi;
